import service from "@irati-tracking/tracker"

export enum MFA_TYPE {
  SMS = "SMS",
  TOTP = "TOTP"
}

interface Details {
  type?: MFA_TYPE
}

class Tracking {
  popupShown() {
    service.trackPlatformEvent("mfa_popup_shown", {})
  }

  popupCancel(details: Details = {}) {
    service.trackPlatformEvent("mfa_popup_cancel", details)
  }

  popupRequestCode(details: Details) {
    service.trackPlatformEvent("mfa_popup_requestCode", details)
  }

  popupComplete(details: Details) {
    service.trackPlatformEvent("mfa_popup_complete", details)
  }

  popupSetupShown(details: Details) {
    service.trackPlatformEvent("mfa_popup_setup_shown", details)
  }

  popupSetupCancel(details: Details) {
    service.trackPlatformEvent("mfa_popup_setup_cancel", details)
  }

  popupSetupComplete(details: Details) {
    service.trackPlatformEvent("mfa_popup_setup_complete", details)
  }
}

const mfaTracking = new Tracking()

export default mfaTracking
